import { ApiService } from 'common/services';

class AccessService extends ApiService {
  getHasAccess = (params: CommonModule.AccessParams) => {
    return this.get('/api/affiliate/overview', { params });
  };
}

export const accessService = new AccessService(process.env.REACT_APP_API_URL);
